import {
  LightingDomainDescriptor,
  LightingDomainType,
  LightingFeatureFlag,
} from '../../../../../types/lightingDomain'
import { getAddress } from '../../../../../utils/common'
import { ADDRESS_TELINK } from '../../../protocols/address'
import { sanitizeLightingLevel } from '../../../../shared/feature-impls/keyboard-lighting/lighting'

export const sideDomain: LightingDomainDescriptor = {
  type: LightingDomainType.Side,
  configSize: 8,
  supportedFeatures:
    LightingFeatureFlag.Brightness |
    LightingFeatureFlag.Speed |
    LightingFeatureFlag.SingleColor |
    LightingFeatureFlag.Colorful,

  addressResolver: {
    getBaseAddr: (configIndex, itemIndex) => {
      return getAddress(ADDRESS_TELINK.SIDE_DYNAMIC_LIGHT_BRIGHTNESS, configIndex, itemIndex)
    },
    getFieldAddr: (field, configIndex, itemIndex) => {
      // 必须查 Telink 自己的侧灯地址表（+0x0098 起）。CH585M 的侧灯偏移是
      // +0x00B4 起，在 Telink 上那片区域是动态模式 11~13 的参数块，借用会改错灯效。
      const fieldAddressMap = {
        brightness: ADDRESS_TELINK.SIDE_DYNAMIC_LIGHT_BRIGHTNESS,
        speed: ADDRESS_TELINK.SIDE_DYNAMIC_LIGHT_SPEED,
        isColorful: ADDRESS_TELINK.SIDE_DYNAMIC_LIGHT_COLOR_TYPE,
      } as const
      const table =
        fieldAddressMap[field as keyof typeof fieldAddressMap] ??
        ADDRESS_TELINK.SIDE_DYNAMIC_LIGHT_BRIGHTNESS
      return getAddress(table, configIndex, itemIndex)
    },
  },

  parser: {
    parse: (buffer, index) => ({
      index,
      domainType: LightingDomainType.Side,
      brightness: sanitizeLightingLevel(buffer[0]),
      speed: sanitizeLightingLevel(buffer[1]),
      isColorful: buffer[2] === 0,
      rgb: { r: buffer[4], g: buffer[5], b: buffer[6] },
      buffer,
    }),
    serialize: (config) => {
      const buf = new Uint8Array(8)
      buf[0] = sanitizeLightingLevel(config.brightness)
      buf[1] = sanitizeLightingLevel(config.speed)
      buf[2] = config.isColorful ? 0 : 1
      buf[3] = 0
      buf[4] = config.rgb?.r ?? 255
      buf[5] = config.rgb?.g ?? 255
      buf[6] = config.rgb?.b ?? 255
      buf[7] = 0
      return buf
    },
  },

  cacheTags: (index, configIndex) => [`light:side:${index}`, `cfg:${configIndex}`],
}
